module.exports = __webpack_public_path__ + "static/media/产品介绍1.409979e2.png";